'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Shareable';

var EntypoShareable = function EntypoShareable(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M6.8,10c0,1.768,1.433,3.201,3.2,3.201c1.768,0,3.199-1.433,3.199-3.201c0-1.767-1.431-3.2-3.199-3.2S6.8,8.233,6.8,10z M4.529,8.8C5.078,6.284,7.318,4.4,10,4.4c1.546,0,2.945,0.627,3.959,1.64c0.469,0.469,1.229,0.469,1.697,0c0.469-0.469,0.469-1.229,0-1.697C14.209,2.896,12.209,2,10,2C6.418,2,3.386,4.354,2.367,7.601H0V10h3.199C4.198,10,4.444,9.187,4.529,8.8z M16.8,10c-0.999,0-1.245,0.814-1.329,1.199c-0.549,2.516-2.789,4.4-5.471,4.4c-1.547,0-2.946-0.627-3.959-1.641c-0.469-0.469-1.229-0.469-1.698,0c-0.468,0.469-0.468,1.229,0,1.697C5.791,17.104,7.791,18,10,18c3.582,0,6.613-2.356,7.633-5.6H20V10H16.8z' })
    );
};

exports.default = EntypoShareable;
module.exports = exports['default'];